import React from 'react';
import { navigateToFeBasedError } from './Navigator';
import FeBasedError from './views/pages/misc/error/FeBasedError';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    navigateToFeBasedError();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <FeBasedError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
